import { render, staticRenderFns } from "./MenuEdit.vue?vue&type=template&id=3e7e84e2&scoped=true&"
import script from "./MenuEdit.vue?vue&type=script&lang=js&"
export * from "./MenuEdit.vue?vue&type=script&lang=js&"
import style0 from "./MenuEdit.vue?vue&type=style&index=0&id=3e7e84e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7e84e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VApp,VCol,VDialog,VIcon,VRow,VSimpleTable,VSpacer,VSwitch})
